var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewMenu),expression:"viewMenu"}],ref:"menu",staticClass:"click-menu direction-ltr context-menu",style:({ top: _vm.top, left: _vm.left }),attrs:{"tabindex":"-1"},on:{"click":_vm.close}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b624fd6c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/block/BlockContextMenu.vue
// module id = 1069
// module chunks = 6